import { render, staticRenderFns } from "./LeaveDetails.vue?vue&type=template&id=de033ec0"
import script from "./LeaveDetails.vue?vue&type=script&lang=js"
export * from "./LeaveDetails.vue?vue&type=script&lang=js"
import style0 from "./LeaveDetails.vue?vue&type=style&index=0&id=de033ec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports